// extracted by mini-css-extract-plugin
export default {"root":"_2AGiW7Qy","content":"_22gMxK-O","line":"_1ByVUGyX","quote":"_2op2IRyF","author":"_23TR1gma"};